import { render, staticRenderFns } from "./static-global-box.vue?vue&type=template&id=5030a2ee&"
import script from "./static-global-box.vue?vue&type=script&lang=js&"
export * from "./static-global-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports